export default __webpack_public_path__ + "static/Inter-Italic-6026cb2a854b19ca73346abf495e4bb7.woff2";